import { HStack, Input, useDisclosure } from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import type {
  WarehouseLocationTemplateDTO,
  WarehousesDTO,
} from "../../../client"
import { WareHouseService } from "../../../client"
import LocationPickerModal from "./LocationPickerModal"
import { useSuggestedWarehouseLocations } from "./useSuggestedWarehouseLocations"

type Props = {
  warehouseId?: string
  productId?: string
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  title?: string
  size?: "sm" | "md" | "lg"
  isDisabled?: boolean
}

export default function WarehouseLocationSelect({
  warehouseId,
  productId,
  value,
  onChange,
  placeholder = "np. A-R001-M001",
  title = "Wybierz lokalizację",
  size = "md",
  isDisabled = false,
}: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { data: warehouses } = useQuery<WarehousesDTO[]>({
    queryKey: ["wms", "warehouses", "list"],
    queryFn: () => WareHouseService.getAllWarehouses(),
    enabled: isOpen && !!warehouseId,
  })
  const template = ((warehouses ?? []).find(
    (warehouse) => warehouse.id === warehouseId,
  )?.location_template ?? null) as WarehouseLocationTemplateDTO | null
  const suggestedLocations = useSuggestedWarehouseLocations({
    isEnabled: isOpen,
    warehouseId,
    productId,
  })

  return (
    <>
      <HStack>
        <Input
          size={size}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          onClick={isDisabled ? undefined : onOpen}
          placeholder={placeholder}
          isReadOnly
          isDisabled={isDisabled}
          cursor={isDisabled ? "not-allowed" : "pointer"}
        />
      </HStack>

      <LocationPickerModal
        isOpen={isOpen}
        onClose={onClose}
        template={template}
        suggestedLocations={suggestedLocations}
        title={title}
        onChoose={(code) => {
          onChange(code)
          onClose()
        }}
      />
    </>
  )
}
